export const formatUrl = (input: string = ''): string => {
  if (input?.startsWith('http')) {
    return input;
  }

  return input !== '' ? `http://${input || ''}` : '';
};
